import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 48px;
  margin-top: 32px;
`

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
  gap: 32px;
`

const Title = styled.div`
  color: ${props => props.theme.blackShade};
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: 44px;
  letter-spacing: 0.5px;
  margin-bottom: 24px;
`

const Highlight = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  max-width: 255px;

  @media (max-width: 1260px) {
    max-width: calc(50% - 32px);
  }

  @media (max-width: 680px) {
    max-width: 100%;
    p {
      margin: 0;
    }
  }

  p {
    color: #000;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0.5px;
  }
`

const TripHighlights = ({ tourHighlights }) => {
  return (
    <Wrapper>
      <Title>Trip highlights</Title>
      <Row>
        {tourHighlights?.details
          ?.map((highlight, index) => (
            <Highlight key={index}>
              <X />
              <span dangerouslySetInnerHTML={{ __html: highlight?.details }} />
            </Highlight>
          ))
          .slice(0, 4)}
      </Row>
    </Wrapper>
  )
}

TripHighlights.propTypes = {
  tourHighlights: PropTypes.object,
}

export default TripHighlights

const X = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <rect
        y="8.25049"
        width="11.4653"
        height="33.689"
        rx="3.35701"
        transform="rotate(-45.2603 0 8.25049)"
        fill="#F5BE41"
      />
      <rect
        x="8.14209"
        y="32"
        width="11.4653"
        height="33.689"
        rx="3.35701"
        transform="rotate(-135 8.14209 32)"
        fill="#F5BE41"
      />
    </svg>
  )
}
